const setItemStorage = (key: string, item: string) => {
  localStorage.setItem(key, item);
};

const getItemStorage = (key: string) => localStorage.getItem(key);
const deleteItemStorage = (key: string) => localStorage.removeItem(key);

export { setItemStorage, getItemStorage, deleteItemStorage };
